import React, { useState } from 'react';
import { IconButton } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ActionMenuDialog from '../common/ActionMenuDialog';
import theme from '../../theme';

const EditDeleteMenuButton = ({ onEdit, onDelete, variant = 'default' }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const buttonSize = variant === 'small' ? { xs: 32, lg: 24 } : { xs: 32, md: 40 };
  const iconSize = variant === 'small' ? { xs: 20, lg: 16 } : { xs: 16, md: 24 };

  return (
    <>
      <IconButton
        disableRipple
        onClick={(e) => setAnchorEl(e.currentTarget)}
        sx={{
          width: buttonSize,
          height: buttonSize,
          border: variant === 'small' ? 'none' : `1px solid ${theme.palette.grey.line}`,
          borderRadius: 1,
        }}
      >
        <MoreVertIcon
          sx={{
            width: iconSize,
            height: iconSize,
            color: theme.palette.black[3],
          }}
        />
      </IconButton>
      <ActionMenuDialog
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        onEdit={onEdit}
        onDelete={onDelete}
      />
    </>
  );
};

export default EditDeleteMenuButton;
